import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

type PageHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
};

export default function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <Box sx={{ textAlign: "center", maxWidth: "700px", mx: "auto", px: 2, pt: 5, pb: description ? 2 : 4 }}>
      <Typography variant="h4" color="secondary.main">
        {title}
      </Typography>
      {description && (
        <Typography variant="h6" color="text.secondary" sx={{ mt: 1.5 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
